import { FB_CAPI_URL } from 'src/utils/constants/ApiConstants';
import { httpService } from '../../../services/fetch/HttpService';
import { getLocalStorage } from 'src/utils/browserStorageHandler';
import { USER_TOKEN } from 'src/utils/constants/localStorageConstants';
import { getCookie } from 'src/components/player/src/utils/Utils';
import { getFBPixelID } from '.';
import { FBC, FBP, FB_LOGIN_ID } from 'src/utils/constants/cookieConstants';
import { DynamicObject } from 'src/utils/commonTypes';
import {
  HTTP_HEADER_KEYS,
  HTTP_HEADER_VALUES,
  HTTP_METHODS
} from 'src/utils/constants/HttpMethodsConstants';

export const putFacebookEvent = async (
  eventName: string,
  timestamp: number,
  sourceUrl: string,
  eventMeta: DynamicObject = {}
) => {
  let headers = [];
  const url = getUrl(eventName);
  const userToken = getLocalStorage(USER_TOKEN);

  if (userToken) {
    headers = [HTTP_HEADER_KEYS.AUTHORIZATION];
  } else {
    headers = [HTTP_HEADER_KEYS.X_Z5_GUEST_TOKEN];
  }

  const customHeader = [
    {
      key: HTTP_HEADER_KEYS.CONTENT_TYPE,
      value: HTTP_HEADER_VALUES.APPLICATION_JSON
    }
  ];

  let body: DynamicObject = {
    thirdPartyData: {
      meta: {
        browserId: getCookie(FBP) || '',
        clickId: getCookie(FBC) || '',
        loginId: getCookie(FB_LOGIN_ID) || '',
        pixelId: getFBPixelID()
      }
    },
    timestamp: timestamp,
    sourceUrl: sourceUrl
  };

  if (Object.keys(eventMeta).length > 0) {
    body = { ...body, eventMeta };
  }

  return httpService.fetchApiData({
    url: url,
    type: HTTP_METHODS.PUT,
    headers: headers,
    body: body,
    customHeader: customHeader
  });
};

const getUrl = (eventId: string) => {
  return `${FB_CAPI_URL}${eventId}`;
};
